import { FC, useCallback, MouseEventHandler } from 'react';
import { Link } from 'dibs-elements/exports/Link';
import { FormattedMessage } from 'dibs-react-intl';
import { useAppDispatch } from '../reducers/root';
import { trackFormInteraction } from '../helpers/checkoutTracking';
import { openLoginModal } from '../actions/checkoutAuthActions';
import dibsCss from 'dibs-css';

export const CheckoutLoginLink: FC = () => {
    const dispatch = useAppDispatch();

    const onLogin = useCallback<MouseEventHandler>(
        event => {
            event.preventDefault();
            trackFormInteraction();
            openLoginModal({ email: null, gaLabel: 'checkout - header', dispatch });
        },
        [dispatch]
    );
    return (
        <div className={`${dibsCss.sassyFontBodySmall}`}>
            <FormattedMessage
                id="checkout.CheckoutLoginLink"
                defaultMessage="Have an account? <a>Log in</a>"
                values={{
                    a: content => <Link onClick={onLogin}>{content}</Link>,
                }}
            />
        </div>
    );
};
